angular.module('internal.announcements', [])
    .config(['$stateProvider',
        /**
         * @param {ui.IStateProvider} $stateProvider
         */
        function ($stateProvider) {
            $stateProvider.state('internal.announcements', {
                url: '/announcements',
                views: {
                    content: {
                        templateUrl: 'js/internal/announcements/announcement-list/announcement-list.html',
                        controller: 'AnnouncementListController',
                        controllerAs: 'vm'
                    }
                }
            });



            // View details
            $stateProvider.state('internal.announcement-details', {
                url: '/announcement-details/:prevState',
                views: {
                    content: {
                        templateUrl: 'js/internal/announcements/announcement-details/announcement-details.html',
                        controller: 'AnnouncementDetailsController',
                        controllerAs: 'vm'
                    }
                }
            });
        }]);